(() => {
  let dispose = () => {};
  function init() {
    dispose();
    const source = document.getElementById('mh-wallet-data');
    if (!source) return;
    const data = JSON.parse(source.textContent);
    const controller = new AbortController();
    const observers = [];
    const $ = id => document.getElementById(id);
    const on = (target, event, handler, options = {}) => target?.addEventListener(event, handler, { ...options, signal: controller.signal });
    const variants = data.variants;
    if (data.productHandle === 'the-ritual') variants.forEach(variant => { if (variant.photos.length > 1) variant.photos.unshift(variant.photos.splice(1, 1)[0]); });
    let selected = variants.find(v => String(v.id) === new URL(location.href).searchParams.get('variant')) || variants.find(v => v.id === data.variantId) || variants[0];
    let photoIndex = 0;
    let changing = false;
    const gallery = $('gallery-main');
    const select = $('mh-variant-id');
    const nav = document.querySelector('.mh-wallet-pdp .section-nav');
    const navSlot = document.createElement('div');
    if (nav) { nav.before(navSlot); navSlot.append(nav); }
    const photos = () => selected.photos;

const desktopGalleryClick = matchMedia('(min-width:960px)');
const galleryOpen = $('gallery-open');
const nextGalleryLabel = document.querySelector('.mh-pdp [data-gallery-next]')?.getAttribute('aria-label') || '';
function canAdvanceGallery() {
 return desktopGalleryClick.matches && photos().length > 1;
}
function syncGalleryClick() {
 const enabled = canAdvanceGallery();
 galleryOpen.classList.toggle('mh-gallery-click-next', enabled);
 galleryOpen.setAttribute('role', enabled ? 'button' : 'group');
 if (enabled) {
  galleryOpen.setAttribute('aria-description', nextGalleryLabel);
  galleryOpen.title = nextGalleryLabel;
 } else {
  galleryOpen.removeAttribute('aria-description');
  galleryOpen.removeAttribute('title');
 }
}
on(desktopGalleryClick, 'change', syncGalleryClick);
on(galleryOpen, 'click', event => {
 if (canAdvanceGallery() && event.button === 0 && event.pointerType !== 'touch' && !event.ctrlKey && !event.metaKey && !event.altKey && !event.shiftKey) movePhoto(1);
});
on(galleryOpen, 'keydown', event => {
 if (canAdvanceGallery() && (event.key === 'Enter' || event.key === ' ')) {
  event.preventDefault();
  if (!event.repeat) movePhoto(1);
 }
});

    function imageSource(url, width) {
      const result = new URL(url, location.href);
      result.searchParams.set('width', width);
      return result.href;
    }
    function setImage(img, photo) {
      if (!img || !photo) return;
      img.srcset = [360, 540, 800, 1100, 1600].map(w => `${imageSource(photo.src, w)} ${w}w`).join(', ');
      img.src = photo.src;
      img.alt = photo.alt;
      img.width = photo.width;
      img.height = photo.height;
    }
    function drawPhoto() {
      const photo = photos()[photoIndex];
      if (!photo) return;
      setImage(gallery, photo);
      $('gallery-counter').textContent = `${photoIndex + 1} / ${photos().length}`;
      $('gallery-caption').textContent = photo.alt;
      $('gallery-open').setAttribute('aria-label', photo.alt);
 syncGalleryClick();
      document.querySelectorAll('#gallery-thumbs button').forEach((b, i) => b.setAttribute('aria-pressed', String(i === photoIndex)));
      document.querySelectorAll('.mh-wallet-pdp [data-gallery-prev], .mh-wallet-pdp [data-gallery-next]').forEach(b => b.hidden = photos().length < 2);
    }
    function movePhoto(delta) {
      if (!photos().length) return;
      photoIndex = (photoIndex + delta + photos().length) % photos().length;
      drawPhoto();
    }
    function updateStoryImages() {
      document.querySelectorAll('[data-wallet-story]').forEach(figure => {
        const role = figure.dataset.walletStory;
        if (figure.querySelector('[data-wallet-flip]')) return;
        if (data.productHandle === 'the-looker-glasses-case' && role === 'capacity') { setImage(figure.querySelector('img'), photos()[1] || photos()[0]); return; }
        const editorial = photos().find(photo => photo.role === role || photo.roles?.includes(role));
        if (editorial) { setImage(figure.querySelector('img'), editorial); return; }
        if (data.requiresMeasurementBounds && role === 'material') { setImage(figure.querySelector('img'), photos()[0]); return; }
        if (data.productHandle === 'the-ritual' && role === 'capacity') { setImage(figure.querySelector('img'), photos().find(photo => /front view/i.test(photo.alt)) || photos()[0]); return; }
        if (figure.hasAttribute('data-wallet-image-fixed')) return;
        const interior = photos().find(p => /open|back view|card slots/i.test(p.alt));
        const inHand = photos().find(p => /hand|with cards/i.test(p.alt));
        setImage(figure.querySelector('img'), role === 'material' || (role === 'capacity' && data.capacityView === 'front') ? photos()[0] : (inHand || interior || photos()[0]));
      });
    }
    document.querySelectorAll('[data-wallet-flip]').forEach(button => {
      const figure = button.closest('[data-wallet-story]');
      const target = figure || button;
      const hover = matchMedia('(hover: hover) and (pointer: fine)');
      if (figure) figure.style.cursor = 'pointer';
      function show(flipped) {
        const side = flipped ? 'pearl' : 'black';
        setImage($(button.getAttribute('aria-controls')), {src:button.dataset[side + 'Src'],alt:button.dataset[side + 'Alt'],width:Number(button.dataset[side + 'Width']),height:Number(button.dataset[side + 'Height'])});
        button.setAttribute('aria-pressed', String(flipped));
      }
      on(target, 'pointerenter', event => {
        if (event.pointerType === 'mouse' && hover.matches) show(true);
      });
      on(target, 'pointerleave', event => {
        if (event.pointerType === 'mouse' && hover.matches) show(false);
      });
      on(target, 'click', event => {
        const mouseHover = hover.matches && event.detail > 0 && event.pointerType !== 'touch';
        show(mouseHover || button.getAttribute('aria-pressed') !== 'true');
      });
      on(hover, 'change', () => show(false));
    });
    const measurementControls = [];
    document.querySelectorAll('[data-wallet-dimension-control]').forEach(button => {
      const view = $(button.getAttribute('aria-controls'));
      const figure = button.closest('[data-wallet-story]');
      function show(visible) {
        view.hidden = !visible;
        button.setAttribute('aria-pressed', String(visible));
        button.textContent = visible ? button.dataset.hideLabel : button.dataset.viewLabel;
      }
      function reset() { show(false); }
      const hover = matchMedia('(hover: hover) and (pointer: fine)');
      const available = () => !data.requiresMeasurementBounds || selected.measurementBounds;
      on(figure, 'pointerenter', event => { if (event.pointerType === 'mouse' && hover.matches && available()) show(true); });
      on(figure, 'pointerleave', event => { if (event.pointerType === 'mouse' && hover.matches) reset(); });
      on(button, 'focus', () => { if (hover.matches && available()) show(true); });
      on(button, 'blur', reset);
      on(figure, 'click', event => {
        event.preventDefault();
        if (available()) show(hover.matches ? true : view.hidden);
      });
      on(button, 'keydown', event => { if (event.key === 'Escape') reset(); });
      on(hover, 'change', reset);
      on(window, 'blur', reset);
      on(document, 'visibilitychange', () => { if (document.hidden) reset(); });
      on(figure, 'contextmenu', event => event.preventDefault());
      on(figure, 'dragstart', event => event.preventDefault());
      measurementControls.push({ view, reset, button });
    });
    function updateMeasurements() {
      measurementControls.forEach(({ view, reset, button }) => {
        reset();
        if (view.classList.contains('mh-bag-dimension-view')) {
          setImage(view.querySelector('.mh-bag-dimension-photo'), selected.dimensionPhoto);
          view.style.setProperty('--mh-dimension-background', (selected.bagDimensionBounds || '').split(',')[4] || '#f3f3f3');
          const geometry = (selected.bagDimensionBounds || '').split(',');
          const [x1,x2,y1,y2] = geometry.map(Number);
          const guides = geometry.slice(5).map(Number);
          const hasGuides = guides.length === 7 && guides.every(Number.isFinite);
          if ([x1,x2,y1,y2].every(Number.isFinite)) {
            const lineY=y2+28,lineX=hasGuides?guides[0]:x1-28,depthX=Math.min(x2+12,930),depthY=y2-65;
            view.querySelector('[data-bag-width-line]').setAttribute('d',`M${x1} ${lineY}H${x2} M${x1+12} ${lineY-8}l-12 8 12 8 M${x2-12} ${lineY-8}l12 8-12 8 M${x1} ${y2+4}v12 M${x2} ${y2+4}v12`);
            view.querySelector('[data-bag-height-line]').setAttribute('d',`M${lineX} ${y1}V${y2} M${lineX-8} ${y1+12}l8-12 8 12 M${lineX-8} ${y2-12}l8 12 8-12 M${lineX+12} ${y1}h12 M${lineX+12} ${y2}h12`);
            const [,depthX1,depthY1,depthX2,depthY2,depthLabelX,depthLabelY] = guides;
            const depthPath = hasGuides
              ? `M${depthX1} ${depthY1}L${depthX2} ${depthY2} M${depthX1+4} ${depthY1-12}l-4 12 13 2 M${depthX2-13} ${depthY2-2}l13 2-4 12`
              : `M${depthX} ${depthY}l45 35 M${depthX+13} ${depthY+2}l-13-2 4 12 M${depthX+41} ${depthY+23}l4 12-13-2`;
            view.querySelector('[data-bag-depth-line]').setAttribute('d',depthPath);
            const labels=view.querySelector('dl');
            Object.entries({'w-x':(x1+x2)/20,'w-y':(lineY+15)/10,'h-x':(lineX-40)/10,'h-y':(y1+y2)/20,'d-x':hasGuides?depthLabelX/10:(depthX+30)/10,'d-y':hasGuides?depthLabelY/10:(depthY-45)/10}).forEach(([key,value])=>labels.style.setProperty('--mh-bag-'+key,value+'%'));
          }
        }
        const bounds = selected.measurementBounds;
        button.hidden = Boolean(data.requiresMeasurementBounds && !bounds);
        if (!bounds || !view.classList.contains('mh-wallet-dimension-view--measured')) return;
        const x1 = Math.max(100, Math.min(800, Number(bounds.x1)));
        const x2 = Math.max(x1, Math.min(950, Number(bounds.x2)));
        const y1 = Math.max(50, Math.min(800, Number(bounds.y1)));
        const y2 = Math.max(y1, Math.min(880, Number(bounds.y2)));
        if (![x1, x2, y1, y2].every(Number.isFinite)) return;
        const lineY = y2 + 28;
        const lineX = Number.isFinite(Number(bounds.heightLineX)) && bounds.heightLineX != null ? Math.max(70, Math.min(x1, Number(bounds.heightLineX))) : x1 - 28;
        const labels = view.querySelector('.mh-wallet-dimension-values');
        view.querySelectorAll('[data-wallet-axis]').forEach(label => {
          const axis = label.dataset.walletAxis;
          if (axis !== 'w' && axis !== 'h') return;
          const position = bounds.swapAxes ? (axis === 'w' ? 'h' : 'w') : axis;
          label.classList.toggle('mh-wallet-dimension-w', position === 'w');
          label.classList.toggle('mh-wallet-dimension-h', position === 'h');
        });
        labels.style.setProperty('--mh-dim-w-left', `${(x1 + x2) / 20}%`);
        labels.style.setProperty('--mh-dim-w-top', `${(lineY + 12) / 10}%`);
        labels.style.setProperty('--mh-dim-h-left', `${(lineX - 40) / 10}%`);
        labels.style.setProperty('--mh-dim-h-top', `${(y1 + y2) / 20}%`);
        view.querySelector('[data-wallet-dimension-width-line]').setAttribute('d', `M${x1} ${lineY}H${x2} M${x1 + 12} ${lineY - 8}l-12 8 12 8 M${x2 - 12} ${lineY - 8}l12 8-12 8 M${x1} ${y2 + 4}v12 M${x2} ${y2 + 4}v12`);
        view.querySelector('[data-wallet-dimension-height-line]').setAttribute('d', `M${lineX} ${y1}V${y2} M${lineX - 8} ${y1 + 12}l8-12 8 12 M${lineX - 8} ${y2 - 12}l8 12 8-12 M${lineX + 12} ${y1}h12 M${lineX + 12} ${y2}h12`);
      });
    }
    function chooseVariant(id, announce = true, notify = true) {
      const variant = variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      selected = variant;
      photoIndex = 0;
      $('selected-color').textContent = variant.title;
      $('sticky-color').textContent = variant.title;
      document.querySelectorAll('.mh-wallet-pdp input[name="mh-color"]').forEach(r => r.checked = r.value === String(variant.id));
      document.querySelectorAll('.mh-wallet-pdp [data-mh-price]').forEach(e => e.textContent = variant.formattedPrice);
      document.querySelectorAll('.mh-wallet-pdp [data-mh-compare]').forEach(e => { e.hidden = variant.compareAtPrice <= variant.price; e.textContent = variant.formattedCompare; });
      document.querySelectorAll('.mh-wallet-pdp [data-add]').forEach(b => b.disabled = !variant.available);
      document.querySelectorAll('.mh-wallet-pdp [data-mh-add-label]').forEach(e => e.textContent = variant.available ? data.labels.add : data.labels.soldOut);
      const stock = $('mh-low-stock');
      stock.hidden = !variant.lowStock;
      stock.textContent = variant.lowStock ? data.labels.lowStock.replace('[count]', variant.lowStock) : '';
      $('wallet-shipping-note').textContent = variant.shippingNote || (variant.price > 15000 ? data.labels.freeShipping : data.labels.shipping);
      const fragment = document.createDocumentFragment();
      photos().forEach((photo, index) => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'thumb'; button.dataset.index = index;
        button.setAttribute('aria-label', photo.alt || `${data.labels.photo} ${index + 1}`);
        const image = document.createElement('img');
        image.src = photo.thumb; image.alt = ''; image.width = 120; image.height = 120; image.loading = 'lazy';
        button.append(image); fragment.append(button);
      });
      $('gallery-thumbs').replaceChildren(fragment);
      drawPhoto(); updateStoryImages(); updateMeasurements();
      if (select.value !== String(variant.id) || notify) {
        changing = true; select.value = variant.id;
        if (notify) select.dispatchEvent(new Event('change', { bubbles: true }));
        changing = false;
      }
      if (announce) {
        $('selection-status').textContent = `${variant.title} · ${variant.formattedPrice}`;
        const url = new URL(location.href); url.searchParams.set('variant', variant.id);
        history.replaceState(history.state, '', url);
      }
    }
    on($('gallery-thumbs'), 'click', event => {
      const button = event.target.closest('button[data-index]');
      if (button) { photoIndex = Number(button.dataset.index); drawPhoto(); }
    });
    document.querySelectorAll('.mh-wallet-pdp input[name="mh-color"]').forEach(r => on(r, 'change', () => chooseVariant(r.value)));
    on(select, 'change', () => { if (!changing) chooseVariant(select.value, true, false); });
    document.querySelectorAll('.mh-wallet-pdp [data-gallery-prev]').forEach(b => on(b, 'click', () => movePhoto(-1)));
    document.querySelectorAll('.mh-wallet-pdp [data-gallery-next]').forEach(b => on(b, 'click', () => movePhoto(1)));
    on($('gallery-open'), 'keydown', e => { if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); movePhoto(e.key === 'ArrowLeft' ? -1 : 1); } });
    let touch;
    on($('gallery-open'), 'touchstart', e => { touch = e.touches.length === 1 ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : null; }, { passive: true });
    on($('gallery-open'), 'touchcancel', () => touch = null, { passive: true });
    on($('gallery-open'), 'touchend', e => {
      if (!touch) return;
      const dx = e.changedTouches[0].clientX - touch.x, dy = e.changedTouches[0].clientY - touch.y;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) { e.preventDefault(); movePhoto(dx < 0 ? 1 : -1); }
      touch = null;
    }, { passive: false });
    const sticky = $('mobile-purchase');
    const guaranteeSection = $('guarantee');
    const mobileGuarantee = matchMedia('(max-width:767px)');
    const sectionLinks = Array.from(nav?.querySelectorAll('a[href^="#"]') || []);
    const sectionTargets = sectionLinks.map(link => $(link.hash.slice(1)));
    function sectionInset(section) {
      return section.id === 'guarantee' ? 0 : parseFloat(getComputedStyle(section).paddingTop) || 0;
    }
    function sizeGuaranteeOverview() {
      if (!guaranteeSection) return;
      if (!mobileGuarantee.matches) { guaranteeSection.style.removeProperty('--mh-guarantee-height'); return; }
      const viewport = window.visualViewport?.height || window.innerHeight;
      const top = (document.querySelector('.site-header')?.offsetHeight || 0) + (nav?.offsetHeight || 0);
      const bottom = sticky?.offsetHeight || 80;
      const height = `${Math.max(0, Math.floor(viewport - top - bottom))}px`;
      if (guaranteeSection.style.getPropertyValue('--mh-guarantee-height') !== height) guaranteeSection.style.setProperty('--mh-guarantee-height', height);
    }
    function updateSticky() {
      const header = document.querySelector('.site-header');
      const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
      const show = innerWidth < 960 && $('add-to-bag').getBoundingClientRect().bottom <= headerBottom;
      sticky.hidden = !show; document.body.classList.toggle('mobile-buy-visible', show);
      const top = Math.min(headerBottom, header?.offsetHeight || 0);
      nav?.style.setProperty('--section-nav-top', `${top}px`);
      if (nav) { navSlot.style.height = `${nav.offsetHeight}px`; nav.classList.toggle('is-pinned', navSlot.getBoundingClientRect().top <= top); }
      document.documentElement.style.setProperty('--mh-section-offset', `${top + (nav?.offsetHeight || 0) + 20}px`);
      sizeGuaranteeOverview();
      const guaranteeBounds = guaranteeSection?.getBoundingClientRect();
      const sectionEdge = top + (nav?.offsetHeight || 0) + 20;
      nav?.classList.toggle('guarantee-active', mobileGuarantee.matches && !!guaranteeBounds && guaranteeBounds.top <= sectionEdge && guaranteeBounds.bottom > sectionEdge);
      let active = -1;
      let closestTop = -Infinity;
      sectionTargets.forEach((section, index) => {
        if (!section) return;
        const contentTop = section.getBoundingClientRect().top + sectionInset(section);
        if (contentTop <= sectionEdge + 4 && contentTop > closestTop) { active = index; closestTop = contentTop; }
      });
      sectionLinks.forEach((link, index) => {
        if (index === active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }
    let scheduled = false;
    const queue = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(() => { scheduled = false; updateSticky(); }); } };
    on(window, 'scroll', queue, { passive: true }); on(window, 'resize', queue); on(window, 'pageshow', queue);
    on(window.visualViewport, 'resize', queue);
    on(nav, 'click', event => {
      const link = event.target.closest('a[href^="#"]');
      const section = link && $(link.hash.slice(1));
      if (!section || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      event.stopPropagation();
      updateSticky();
      const header = document.querySelector('.site-header');
      const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
      const top = Math.min(headerBottom, header?.offsetHeight || 0) + (nav?.offsetHeight || 0);
      const gap = section.id === 'guarantee' ? 0 : 16;
      const destination = window.scrollY + section.getBoundingClientRect().top + sectionInset(section) - top - gap;
      const url = new URL(location.href); url.hash = section.id;
      history.replaceState(history.state, '', url);
      window.scrollTo({ top: Math.max(0, destination), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }, { capture: true });
    on(document.querySelector('[data-mh-sticky-add]'), 'click', () => { if (!$('add-to-bag').disabled) $('add-to-bag').click(); });
    on(window, 'popstate', () => chooseVariant(new URL(location.href).searchParams.get('variant') || data.variantId, false));
    on(document.querySelector('a[href="#shipping-details"]'), 'click', () => $('shipping-details').open = true);
    document.querySelectorAll('.mh-wallet-pick-color, .mh-wallet-choose-color[href="#top"]').forEach(link => {
      on(link, 'click', event => {
        event.preventDefault();
        event.stopPropagation();
        const url = new URL(location.href);
        url.hash = 'top';
        history.replaceState(history.state, '', url);
        window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
    });
    const reviewRoot = $('reviews');
    if (reviewRoot) {
      const reviewLabels = JSON.parse(reviewRoot.querySelector('[data-review-labels]').textContent);
      const photoDialog = document.createElement('dialog'); photoDialog.className = 'dialog review-photo-dialog';
      const close = document.createElement('button'); close.type = 'button'; close.className = 'icon-button'; close.textContent = '×'; close.setAttribute('aria-label', reviewLabels.close_photo);
      const photo = document.createElement('img'); photo.className = 'review-photo-large';
      photoDialog.append(close, photo); reviewRoot.append(photoDialog); let photoOpener;
      on(reviewRoot, 'click', e => { const trigger = e.target.closest('.review-photo'); if (!trigger) return; const img = trigger.querySelector('img'); if (!img) return; e.preventDefault(); e.stopImmediatePropagation(); photoOpener = trigger; photo.src = img.currentSrc || img.src; photo.alt = img.alt; photoDialog.setAttribute('aria-label', img.alt || reviewLabels.photo); photoDialog.showModal(); }, { capture: true });
      on(close, 'click', () => photoDialog.close()); on(photoDialog, 'close', () => photoOpener?.focus({ preventScroll: true }));
      observers.push({ disconnect: () => photoDialog.remove() });
    }
    function preservePreview() { if (data.previewThemeId) { const url = new URL(location.href); url.searchParams.set('preview_theme_id', data.previewThemeId); history.replaceState(history.state, '', url); } }
    on(window, 'load', preservePreview); if (document.readyState === 'complete') preservePreview();
    chooseVariant(selected.id, false); updateSticky();
    document.documentElement.classList.add('mh-ltt-ready', 'mh-wallet-ready');
    dispose = () => { controller.abort(); observers.forEach(o => o.disconnect()); guaranteeSection?.style.removeProperty('--mh-guarantee-height'); sectionLinks.forEach(link => link.removeAttribute('aria-current')); if (nav) { nav.classList.remove('is-pinned', 'guarantee-active'); navSlot.replaceWith(nav); } document.documentElement.classList.remove('mh-ltt-ready', 'mh-wallet-ready', 'modal-open'); document.body.classList.remove('mobile-buy-visible'); };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => { if (event.target.querySelector('#mh-wallet-data')) dispose(); });
})();






